import React, { useState, useContext } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';

import { RequestNoteFormValues } from '../../../../App/models/RequestNote'
import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import TextAreaInput from '../../../../App/common/form/TextAreaInput';
import SelectInput from '../../../../App/common/form/SelectInput';

import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthLessThan
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'


const validate = combineValidators({
  requestId: isRequired('requestId'),
  noteType: isRequired('noteType'),
  note: composeValidators(
    isRequired('note'),
    hasLengthLessThan(300)({ message: 'Notes have a 300 char limit' })
  )(),
});

interface NoteParams {
  requestId: string;
  requestReviewId: string;
  requestNoteId: string;
  note: string;
  noteType: string;
}

const RequestNoteForm: React.FC<NoteParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { createRequestNote, submitting } = rootStore.requestNoteStore;
  const { closeModal } = rootStore.modalStore;
  const { getNoteOptions } = rootStore.commonStore;
  const { UnlockRequest } = rootStore.requestReviewUnlockStore;
  const { loadRequestNotes } = rootStore.requestNoteStore;

  const [requestNote] = useState(new RequestNoteFormValues(match.requestId));
  requestNote.note = match.note;
  requestNote.id = match.requestNoteId;
  requestNote.noteType = match.noteType;

  const [loading] = useState(false);


  const handleFinalFormSubmit = (values: any) => {
    const { ...requestNote } = values;
    createRequestNote(requestNote)
      .then(r => loadRequestNotes(match.requestReviewId));
  };


  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={requestNote}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>

            <Field
              component={SelectInput}
              options={getNoteOptions(["Administrative Reopening"])}
              name='noteType'
              placeholder='NoteType'
              value={requestNote.noteType}
            />

            <Field
              rows={4}
              name='note'
              placeholder='Note'
              value={requestNote.note}
              component={TextAreaInput}
            />

            {requestNote.note === '' ?
              <Button
                loading={submitting}
                disabled={loading || invalid || pristine || submitting}
                onClick={async () => await UnlockRequest(match.requestReviewId, match.requestId)}
                floated='right'
                className={'rl-btn'}
                positive
                type='submit'
                content='Unlock'
              />
              :
              <Button
                loading={submitting}
                disabled={loading || invalid || pristine || submitting}
                floated='right'
                positive
                type='submit'
                content='Submit'
              />
            }

            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(RequestNoteForm);
